import api from '../instance/axios_instance.ts';
import { DataType } from '../interface/dataTypeInterface.ts';
const DataTypeApi = async () : Promise<DataType> => {

    try {
        const response = await api.get<DataType>('/data_type', {skipAuth: true} as any);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }

};

export default DataTypeApi;